import React from 'react'
import LFlex from "../../components/lui/layout/lflex/LFlex"
import LGrid from "../../components/lui/layout/lgrid/LGrid"
import AppListItem from "./widgets/AppListItem"
import data_ru from './data_ru.json'
import data_en from './data_en.json'
import AppState from "../../../domain/contexts/AppState"
import openDonateModal, {DonateModalCfg} from "../../widgets/donate_modal/DonateModal"
import {observer} from "mobx-react"


/**
 *  @returns {JSX.Element}
 *  @constructor
 */
function PageProjects() {

    const langData = {
        'en': data_en,
        'ru': data_ru
    }

    const data = langData[AppState.instance.lang]


    const donatePressed = async (name) => {
        const cfg = new DonateModalCfg()
        cfg.payment.title = data['donate-modal']['paymentTitle']
        cfg.commentTitle = data['donate-modal']['commentTitle']
        cfg.paymentType = data['donate-modal']['paymentType']
        cfg.submitLabel = data['donate-modal']['submitLabel']

        await openDonateModal({
            title: data['donate-modal'].title.replaceAll('{name}', name ),
            cfg: cfg
        })
    }


    const rows = data['projects'].map( (row, index) => (
        <AppListItem key={index}
            image={row['image']}
            title={row['title']}
            subtitle={row['subtitle']}
            rawText={row['text']}
            storeLinks={row['storeLinks']}
            donateLabel={row['donateLabel']}
            donatePressed={ ()=>donatePressed(row['title']) }
        />
    ))


    return (
        <LFlex vertical className='w100 h100 wrap jc-center'>
            <LGrid className='gap3 w100 ac-center jc-center ai-start content-margin-top content-margin-bottom'
               style={{gridTemplateColumns: 'repeat( auto-fit, minmax(auto, 480px) )'}}
            >
                {rows}
            </LGrid>
        </LFlex>
    )

}

export default observer(PageProjects)
